namespace Riepiloghi.Administration {
    export class UserColumns {
        static columnsKey = 'Administration.User';
    }
}
